/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React from "react";
import CardHistorico from "screens/lead/components/cardHistorico/cardHistorico.component";
import { useLogsLead } from "services/api";
import * as Styles from "./styles";

const PAGE_SIZE = 8;

interface Props {
  idLeadCorretor: string | undefined;
  tabValue?: number;
}

interface HistoricParams {
  tipoLogLead: number | undefined;
}

export function HistoricoSection(props: Props) {
  const [historicParams, setHistoricParams] = React.useState<HistoricParams>({
    tipoLogLead: 0,
  });
  const [visibleCount, setVisibleCount] = React.useState(PAGE_SIZE);
  const sentinelRef = React.useRef<HTMLDivElement>(null);
  const listRef = React.useRef<HTMLDivElement>(null);

  const { data: dataHistorico, isLoading: loadingHistorico } = useLogsLead({
    idLeadCorretor: props.idLeadCorretor,
    tipoLogLead: historicParams.tipoLogLead,
    queryKey: "historico-lead-details",
  });

  // Reset visible count when filter or lead changes
  React.useEffect(() => {
    setVisibleCount(PAGE_SIZE);
  }, [props.idLeadCorretor, historicParams.tipoLogLead]);

  // IntersectionObserver para carregar mais ao chegar no fim
  React.useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          dataHistorico &&
          visibleCount < dataHistorico.length
        ) {
          setVisibleCount((prev) =>
            Math.min(prev + PAGE_SIZE, dataHistorico.length)
          );
        }
      },
      { root: listRef.current, threshold: 0.1 }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [visibleCount, dataHistorico]);

  const handleHistoricFilter = (value: number) => {
    setHistoricParams({ tipoLogLead: value });
  };

  const visibleItems = dataHistorico
    ? dataHistorico.slice(0, visibleCount)
    : [];

  return (
    <Styles.FormControl size="small">
      <Styles.Select
        color="secondary"
        value={historicParams?.tipoLogLead}
        label="Status"
        variant="outlined"
        onChange={(event: any) => {
          handleHistoricFilter(event.target.value);
        }}
        className="select-historic"
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
      >
        <Styles.MenuItemSelect value={0}>Todos</Styles.MenuItemSelect>
        <Styles.MenuItemSelect value={1}>Alteração</Styles.MenuItemSelect>
        <Styles.MenuItemSelect value={2}>Tarefas</Styles.MenuItemSelect>
        <Styles.MenuItemSelect value={3}>Etapa</Styles.MenuItemSelect>
        <Styles.MenuItemSelect value={4}>Desqualificação</Styles.MenuItemSelect>
        <Styles.MenuItemSelect value={5}>
          Compartilhamento
        </Styles.MenuItemSelect>
        <Styles.MenuItemSelect value={6}>Transferência</Styles.MenuItemSelect>
      </Styles.Select>

      <Styles.ListWrapper ref={listRef}>
        {loadingHistorico ? (
          <Styles.CircularProgressTasks />
        ) : visibleItems.length > 0 ? (
          <>
            {visibleItems.map((item: any, index: any) => (
              <CardHistorico
                key={index}
                codigoTipoLogLead={item.codigoTipoLogLead}
                idCorretorRealizacaoAcao={item.idCorretorRealizacaoAcao}
                idLead={item.idLead}
                idLeadCorretor={item.idLeadCorretor}
                idTipoLogLead={item.idTipoLogLead}
                nome={item.nome}
                valores={item.valores}
                nomeCorretor={item.nomeCorretor}
                nomeFotoCorretor={item.nomeFotoCorretor}
                dataAtualizacao={item.dataAtualizacao}
                nomeStatusTarefa={item.nomeStatusTarefa}
                nomeTipoTarefa={item.nomeTipoTarefa}
                observacao={item.observacao}
                nomeMotivoDesqualificacaoLead={
                  item.nomeMotivoDesqualificacaoLead
                }
                nomeCorretorDestino={item.nomeCorretorDestino}
                resultado={item?.tipoResultadoTarefa}
              />
            ))}
            {visibleCount < (dataHistorico?.length ?? 0) && (
              <div ref={sentinelRef} style={{ height: 1 }} />
            )}
          </>
        ) : (
          <Styles.Text style={{ textAlign: "center", marginTop: 35 }}>
            Sem histórico para esse Lead
          </Styles.Text>
        )}
      </Styles.ListWrapper>
    </Styles.FormControl>
  );
}
